import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { FiCheckCircle, FiXCircle } from "react-icons/fi"; // Icons für Buttons

// Einfaches Bestätigungsmodal für die Veröffentlichung
function PublishConfirmModal({ show, onHide, onConfirm, tournamentName, loading }) {
  const [sendEmail, setSendEmail] = React.useState(true);

  const handleConfirm = () => {
    onConfirm(sendEmail);
  };

  return (
    <Modal show={show} onHide={onHide} centered size="md">
      <Modal.Header closeButton className='border-0 rakete-rot'>
        <Modal.Title className='rakete-font fw-semibold text-uppercase fs-6'>Veröffentlichung Bestätigen</Modal.Title>
      </Modal.Header>
      <Modal.Body className='text-center py-2'>
        <strong className='rakete-font'>{tournamentName || 'Unbekanntes Turnier'}</strong> <br />
        wirklich veröffentlichen?

        <div className="form-check form-switch d-flex justify-content-center align-items-center mt-4 gap-2">
          <input
            className="form-check-input"
            type="checkbox"
            role="switch"
            id="sendEmailSwitch"
            checked={sendEmail}
            onChange={(e) => setSendEmail(e.target.checked)}
          />
          <label className="form-check-label" htmlFor="sendEmailSwitch">Einladungs-E-Mails senden</label>
        </div>

        {sendEmail && (
          <div className='fs-7 text-justify mt-2 ms-2 text-muted'>
            <span className='fw-semibold text-danger'>Hinweis:</span> Es werden automatisch Einladungen an alle Kontakte im Verteiler gesendet.
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className='border-0 justify-content-center'>
        <button
          className="text-center decline-button text-uppercase rounded fw-semibold fs-7"
          type="button"
          onClick={onHide}
          disabled={loading}
        >
          <FiXCircle className="me-1" /> Abbrechen
        </button>
        <button
          className="text-center login-button text-uppercase rounded fw-semibold border border-0 fs-7"
          type="button"
          onClick={handleConfirm}
          disabled={loading}
        >
          {loading ? 'Wird veröffentlicht...' : <><FiCheckCircle className="me-1" /> Veröffentlichen</>}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default PublishConfirmModal;